import React, {Component} from 'react'
import classNames from "classnames";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput/OutlinedInput";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl/FormControl";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import IconButton from "@material-ui/core/IconButton/IconButton";
import { ReactComponent as Visibility } from 'images/icons/eye.svg'
import { ReactComponent as VisibilityOff } from 'images/icons/hidden.svg'
import InputMask from 'react-input-mask';

const initialState = {
    error: "",
    value: "",
    focus: false,
    show: false,
}

class TextField extends Component {
    constructor(props) {
        super(props)
        this.state = initialState
        this.validate = this.validate.bind(this)
        this.cleanInput = this.cleanInput.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleClickShowPassword = this.handleClickShowPassword.bind(this)
    }

    cleanInput() {
        this.setState(initialState)
    }

    handleClickShowPassword() {
        this.setState(prevState => ({show: !prevState.show}));
    }

    handleChange(e) {
        if (this.props.maxLength) {
            (e.target.value.length <= this.props.maxLength) && this.setState({value: e.target.value})
        } else {
            this.setState({value: e.target.value});
        }
    }

    validate() {
        const value = this.state.value,
            name = this.props.name

        if (this.props.isrequired && `${value}`.trim() === '') {
            this.setState({error: 'Campo obrigatório'})
            this.props.onChange(name, value, true)
            return false
        }
        if (this.props.unique && Array.isArray(this.props.unique) && this.props.unique.filter(x => typeof x === 'string' && x.toLowerCase().trim() === value.toLowerCase().trim()).length > 0) {
            this.setState({error: 'Campo já existe'})
            this.props.onChange(name, value, true)
            return false
        }

        if (this.props.type === 'e-mail' && !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) {
            this.setState({error: 'Email inválido'})
            this.props.onChange(name, value, true);
            return false
        }

        this.props.onChange(name, value, false)
        this.setState({error: ''})
        return true
    }

    render() {
        const {error, value, show, focus} = this.state
        const {id, label, type, errorMessage, showPassword, isrequired, mask, placeholder, ...props} = this.props
        const isCompatible = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) || /constructor/i.test(window.HTMLElement) || ((p) => p.toString() === "[object SafariRemoteNotification]")(!window['safari'] || (typeof window.safari !== 'undefined' && window.safari.pushNotification));

        return (

            <FormControl error={error !== ''} className={classNames({
                error: (error !== '' || errorMessage),
                focus: focus,

            }, `form_container ${props.className}`)}
                fullWidth={this.props.fullWidth || false}>
                {label &&
                <InputLabel shrink={true} htmlFor={id}> {label}{isrequired && `*`}</InputLabel>}
                {mask ? <InputMask maskChar=' ' mask={mask} id={id} isrequired={(isrequired !== undefined) ? isrequired.toString() : 'false'} value={value}
                                   onChange={this.handleChange}>
                    {(inputProps) => <OutlinedInput {...inputProps} name={props.name} labelWidth={0}
                                                    classes={{root: 'input_container', notchedOutline: 'input_border'}}
                                                    type={'text'}/>}
                </InputMask> : <OutlinedInput
                    {...props}
                    labelWidth={0}
                    classes={{root: 'input_container', notchedOutline: 'input_border'}}
                    id={id}
                    isrequired={(isrequired !== undefined) ? isrequired.toString() : 'false'}
                    onFocus={() => this.setState({focus: true})}
                    onBlur={() => this.setState({focus: false})}
                    onChange={this.handleChange}
                    inputRef={el => this.input = el}
                    autoComplete={props.autoComplete}
                    placeholder={placeholder}
                    value={value}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={(isCompatible && showPassword && !show) ? {
                        style:{
                            'WebkitTextSecurity': 'disc',
                        },

                    } : {autoComplete: props.autoComplete}}
                    type={(!isCompatible && showPassword && !show) ? 'password' : (!showPassword && type) ? type : 'text'}
                    endAdornment={
                        showPassword ? <InputAdornment position="end">
                            <IconButton
                                aria-label="Toggle password visibility"
                                onClick={this.handleClickShowPassword}>
                                {show ? <Visibility color='#4DBCAC'/> : <VisibilityOff color='#4DBCAC'/>}
                            </IconButton>
                        </InputAdornment> : ''}
                />
                }
                {(error !== '') && <FormHelperText>{error}</FormHelperText>}
                {(errorMessage && error === '') && <FormHelperText>{errorMessage}</FormHelperText>}
            </FormControl>)
    }
}

export default TextField
